// Reprise — client-side balance knobs, all in one place (see REPRISE.md §9's
// "sizing is the thing to get wrong"). The authoritative economy limits live
// server-side in the reprise_config table (supabase/reprise-schema.sql), tuned
// by UPDATE without a redeploy. This file holds the knobs the CLIENT owns —
// the run-worth formula, the world-buff bracket, counter-pressure — plus
// display MIRRORS of two server values (pull cost, trade fee) that are shown
// in the UI. The mirrors must be kept in step with reprise_config by hand;
// they're display-only (the server re-charges the real amount regardless), so
// drift misreads a label but can't be exploited.
export const REPRISE_TUNING = {
  // Run-worth: how a finished run converts to Resonance (R0) / finale damage
  // (R5). The server re-clamps to its own per-run cap, so this only has to be
  // roughly fair. See RepriseClient.calcResonance.
  resonancePerBoss: 300,
  resonancePerSecond: 2,
  resonanceAscensionStep: 0.2, // +20% run-worth per Ascension level

  // Per-act overrides of the rate above — RepriseClient.calcResonance looks up
  // `<actId>ResonancePerBoss` (data/acts.js for the ids). Flat keys rather than
  // a nested map because every value in this file is a plain number and the
  // test asserts exactly that.
  //
  // Every act is a standalone run now, and they are not the same size or
  // difficulty: Act I is seven of the game's easiest bosses in ~19 minutes,
  // Acts II and III are six of its hardest in ~17. One flat per-boss rate would
  // price Act I's court the same as the Undersong's deep, so the two deep acts
  // pay slightly more per boss — enough to rank a deep clear above a court
  // clear, not enough to make Act I not worth running.
  //
  // Act I has no entry on purpose: it uses `resonancePerBoss` above, which is
  // the baseline the server's per-run cap was sized against.
  act2ResonancePerBoss: 340,
  act3ResonancePerBoss: 340,

  // World buffs (R2): the fourth bonus bracket restored districts grant.
  worldMultCap: 0.35,          // max +35% on any one multiplicative stat
  weaponStartLevelCap: 4,      // weapons cap at 8; keep the Foundry bonus sane
  extraLevelUpChoiceCap: 2,

  // Counter-pressure (R2): enemies harden as the world heals.
  counterPressurePerDistrict: 0.0075,
  counterPressureCap: 0.15,

  // Display mirrors of reprise_config (server is authoritative). Keep in step.
  pullUnitCost: 15,            // mirror: reprise_config.pull_unit_cost
  tradeFee: 5,                 // mirror: reprise_config.trade_fee
};
